module.exports = __webpack_public_path__ + "static/media/ALLogo.36387a5c.svg";